import { render, staticRenderFns } from "./index.vue?vue&type=template&id=618c6f4a&scoped=true"
import script from "./confirmCode.js?vue&type=script&lang=js&external"
export * from "./confirmCode.js?vue&type=script&lang=js&external"
import style0 from "./styles.scss?vue&type=style&index=0&id=618c6f4a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618c6f4a",
  null
  
)

export default component.exports